export default function CommentIcon() {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.996 1C5.48713 1 1.0041 5.18327 1.0041 10.3258C1.01003 12.188 1.60199 14.0012 2.69606 15.5082C2.44639 16.1004 2.14198 16.668 1.7868 17.2035L1.34049 17.8697C1.13793 18.1706 1.02113 18.5211 1.00261 18.8834C0.984086 19.2457 1.06455 19.6063 1.23537 19.9263C1.40618 20.2464 1.66091 20.5139 1.97222 20.7002C2.28353 20.8865 2.63968 20.9845 3.00248 20.9838C4.86222 20.9867 6.67224 20.3834 8.1583 19.2652C9.08224 19.5224 10.0369 19.6524 10.996 19.6515C16.5049 19.6515 20.9879 15.4683 20.9879 10.3258C20.9879 5.18327 16.5049 1 10.996 1ZM10.996 17.6532C9.87152 17.6538 8.75791 17.4331 7.71866 17.0037C7.10337 17.6304 6.36949 18.1284 5.55979 18.4687C4.75009 18.8089 3.88076 18.9846 3.00248 18.9854L3.44878 18.3193C4.09937 17.3318 4.61045 16.2592 4.96755 15.1319C3.71631 13.8438 3.0121 12.1215 3.00248 10.3258C3.00248 6.27905 6.58291 2.99838 10.996 2.99838C15.4091 2.99838 18.9895 6.27905 18.9895 10.3258C18.9895 14.3725 15.4091 17.6532 10.996 17.6532Z"
        fill="white"
      />
      <path
        d="M6.99919 11.3246C7.55103 11.3246 7.99838 10.8772 7.99838 10.3254C7.99838 9.77352 7.55103 9.32617 6.99919 9.32617C6.44735 9.32617 6 9.77352 6 10.3254C6 10.8772 6.44735 11.3246 6.99919 11.3246Z"
        fill="white"
      />
      <path
        d="M14.9924 11.3246C15.5442 11.3246 15.9915 10.8772 15.9915 10.3254C15.9915 9.77352 15.5442 9.32617 14.9924 9.32617C14.4405 9.32617 13.9932 9.77352 13.9932 10.3254C13.9932 10.8772 14.4405 11.3246 14.9924 11.3246Z"
        fill="white"
      />
      <path
        d="M10.9958 11.3246C11.5476 11.3246 11.995 10.8772 11.995 10.3254C11.995 9.77352 11.5476 9.32617 10.9958 9.32617C10.4439 9.32617 9.99658 9.77352 9.99658 10.3254C9.99658 10.8772 10.4439 11.3246 10.9958 11.3246Z"
        fill="white"
      />
    </svg>
  );
}
